import { gql } from "@apollo/client";

export const GET_MANAGERS = gql`
    query GetManagers($q: String!, $page: Int, $pageSize: Int) {
        managers(q: $q, page: $page, pageSize: $pageSize) {
            objects {
                id
                fullName
                profileOrganizations {
                    organization { id name }
                    group {
                        id
                    }
                }
                logoUrl
            }
            page
            pages
            hasNext
            hasPrev
        }
    }
`;
